import { useAppVersion } from '@/stores/settingsStore';

const AppVersion = () => {
  const version = useAppVersion();

  return <div className="text-xs text-gray-500 z-[400]">v{version}</div>;
};

export default AppVersion;
